import styled, { css } from 'styled-components';
import '../List/index.js';
import { ListHeader } from '../List/List.styles.js';

const tableReset = css `
  width: auto;
  height: auto;
  margin: 0;
  padding: 0;
  border: none;
  border-collapse: inherit;
  border-spacing: 0;
  border-color: inherit;
  text-align: left;
  font-weight: inherit;
  -webkit-border-horizontal-spacing: 0;
  -webkit-border-vertical-spacing: 0;
`;
const TableHeaderStyle = styled.tr `
  ${tableReset};
  padding-bottom: 8px;
`;
const TableHead = styled.thead `
  ${tableReset};
`;
const TableHeaderCell = styled(ListHeader).attrs({ as: 'th' }) `
  /* 16px (8px + 8px) because TableHeader don't show margin */
  padding: 8px 12px 16px;
`;
const TableCell = styled.td(({ theme }) => css `
    ${tableReset};

    padding: 12px 0px 12px 12px;
    line-height: 1.4;

    font-size: ${theme.fontSizes.D};
    font-weight: ${theme.fontWeights.regular};
    color: ${theme.colors.foreground.secondary.D};
  `);
const TableRow = styled.tr `
  ${tableReset};
  border-radius: ${({ theme }) => theme.radii.large};

  /* Animate the background change */
  transition: background 250ms ease-in-out;

  ${ /* sc-selector */TableCell}:nth-child(1) {
    border-top-left-radius: ${({ theme }) => theme.radii.large};
    border-bottom-left-radius: ${({ theme }) => theme.radii.large};
  }

  ${ /* sc-selector */TableCell}:nth-last-child(1) {
    padding-right: 12px;
    border-top-right-radius: ${({ theme }) => theme.radii.large};
    border-bottom-right-radius: ${({ theme }) => theme.radii.large};
  }
`;
const TableBody = styled.tbody `
  ${tableReset};
`;
const TableStyle = styled.table `
  ${tableReset};

  ${({ $evenColumns }) => $evenColumns &&
    css `
      table-layout: fixed;
      width: 100%;
    `}

  ${({ $hideHeader }) => $hideHeader &&
    css `
      ${TableHead} {
        visibility: collapse;
      }
    `}

  ${ /* sc-selector */TableRow} {
    :nth-child(odd) {
      background-color: ${({ theme }) => theme.colors.background.secondary.B};
      z-index: -1; /* Fix for scrollbar going under odd rows */
    }

    :hover {
      background-color: ${({ theme }) => theme.colors.state.hover};
    }
  }
`;

export { TableBody, TableCell, TableHead, TableHeaderCell, TableHeaderStyle, TableRow, TableStyle };
